<template>
  <div class="actionsRow">
    <v-tooltip top v-if="permissions.catalog.additional.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="toggle_(additional)"
        >
          <v-icon >{{ (!additional.active ? 'mdi-checkbox-marked-circle-outline' : 'mdi-cancel') }}</v-icon>
        </v-btn>
      </template>
      <span>{{ (additional.active ? lang.additional.status.deactivate : lang.additional.status.activate) }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.additional.actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="$emit('edit', additional)"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.additional.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.catalog.additional.actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="delete_(additional)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.additional.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import actions from '../mixins/actions'

export default {
  mixins: [ appdata, actions ],
  props: {
    additional: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
#app .actionsRow {
  width: 109px;
}
</style>
